import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["bg-blue-light rounded h-12 w-48 text-center px-2", _ctx.disabled ? 'cursor-not-allowed text-white' : ''])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}